/**
 * Created by dx.yang on 2017/3/8.
 */



export default {
    name: 'KsTooltipAdv',
    data() {
        return {
            timer: null,
            showContent: false,
        };
    },
    mounted() {
    },
    methods: {
        mouseoverHandler(fromMark) {
            clearTimeout(this.timer);

            if (fromMark) {
                document.body.appendChild(this.$refs.trans);
                $(this.$refs.trans).show();
                setTimeout(() => {
                    let mark = this.$refs.mark;
                    let offset = $(mark).offset();
                    let width = $(mark).outerWidth();
                    let height = $(mark).outerHeight();

                    offset.top += height;

                    if (offset.left + $(this.$refs.trans).width() > $(window).width()) {
                        offset.left = offset.left -  $(this.$refs.trans).width();
                    }

                    if (offset.top + $(this.$refs.trans).height() > $(window).height()) {
                        offset.top = offset.top - height * 1.9 - $(this.$refs.trans).height();// - document.body.scrollHeight;
                    }

                    $(this.$refs.trans).css(offset);
                }, 0);

            }

        },
        mouseoutHandler() {
            let trans = this.$refs.trans;
            let transBox = this.$refs.transBox;
            this.timer = setTimeout(() => {
                $(trans).hide();
                this.$nextTick(() => {
                    transBox.appendChild(trans);
                });
                // });
            }, 0);
        },
        // hide() {},

        // oncopy(success) {
        //
        // }
    },
    // render(h) {
    //     return (
    //         <div on-mouseover={ this.show }>
    //             <div>{this.$slots.mark}</div>
    //             <div>{this.$slots.content}</div>
    //         </div>
    //     );
    // }
};
